/* eslint-disable import/no-default-export,jsx-a11y/no-noninteractive-element-interactions */
import { Key, Scope, useShortcut } from '@trello/keybindings';
import React, { useCallback } from 'react';

import classNames from 'classnames';

import styles from './overlay.less';
import { AllProps, OverlayBackground } from './types';
import {
  useCurrentElevation,
  useCallbackRef,
  ELEVATION_ATTR,
  useClickOutsideHandler,
} from '@trello/layer-manager';

export const Overlay: React.FunctionComponent<AllProps> = ({
  background = OverlayBackground.LIGHT,
  className = '',
  closeOnEscape = true,
  children,
  onClose = () => {},
}) => {
  const [containerElement, containerRef] = useCallbackRef<HTMLDivElement>();
  const [contentsElement, contentsRef] = useCallbackRef<HTMLDivElement>();
  const elevation = useCurrentElevation(containerElement);

  const handleEscape = () => {
    if (closeOnEscape) {
      onClose();
    }
  };

  // Set up an 'elevation aware' outside click handler to detect clicks outside the
  // content of the overlay
  const handleClickOutside = useCallback(
    (event: MouseEvent) => {
      if (event.defaultPrevented) {
        return;
      }
      onClose();
    },
    [onClose],
  );
  useClickOutsideHandler({ element: contentsElement, handleClickOutside });

  useShortcut(handleEscape, {
    scope: Scope.Overlay,
    key: Key.Escape,
  });

  return (
    <div
      className={classNames(styles.overlay, styles[background], className)}
      role="dialog"
      ref={containerRef}
    >
      <div
        ref={contentsRef}
        className={styles.contents}
        {...{ [ELEVATION_ATTR]: elevation + 1 }}
      >
        {children}
      </div>
    </div>
  );
};
